import { defineComponent, h, onMounted, ref, resolveComponent } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

import {
  CBadge,
  CSidebarNav,
  CNavItem,
  CNavGroup,
  CNavTitle,
} from '@coreui/vue'

import superAdmin from '@/navBar/super_admin'
import socio from '@/navBar/socio'
import admin from '@/navBar/admin'
import gerenteJogo from '@/navBar/gerente_jogo'
import gestorResultado from '@/navBar/gestor_resultado'
import marketing from '@/navBar/marketing'
import custom from '@/navBar/custom'

const normalizePath = (path) =>
  decodeURI(path)
    .replace(/#.*$/, '')
    .replace(/(index)?\.(html)$/, '')

const isActiveLink = (route, link) => {
  if (link === undefined) {
    return false
  }

  if (route.hash === link) {
    return true
  }

  const currentPath = normalizePath(route.path)
  const targetPath = normalizePath(link)

  return currentPath === targetPath
}

const isActiveItem = (route, item) => {
  if (isActiveLink(route, item.to)) {
    return true
  }

  if (item.items) {
    return item.items.some((child) => isActiveItem(route, child))
  }

  return false
}

const AppSidebarNav = defineComponent({
  name: 'AppSidebarNav',
  components: {
    CNavItem,
    CNavGroup,
    CNavTitle,
  },
  setup() {
    const route = useRoute()
    const firstRender = ref(true)
    let permissao = []
    const user = JSON.parse(localStorage.getItem('user'))
    const modulesPermission = user?.modules_permission
      ? JSON.parse(user?.modules_permission)
      : []
    switch (user.role) {
      case 'socio':
        permissao = socio
        break
      case 'super_admin':
        permissao = superAdmin
        break
      case 'admin':
        permissao = admin
        break
      case 'gerente_jogo':
        permissao = gerenteJogo
        break
      case 'gestor_resultado':
        permissao = gestorResultado
        break
      case 'marketing':
        permissao = marketing
        break
      default:
        permissao = custom
        console.log(`permissao padrao`)
    }

    const filtrarItens = (items) => {
      let filtrados = items
        .map((item) => {
          if (item.items) {
            item.items = filtrarItens(item.items)
            return item.items.length > 0 ? item : null
          }
          if (item.component === 'CNavTitle') {
            return item
          }
          if (
            item.to === '/dashboard' ||
            item.name === 'Dashboard' ||
            item.name === 'Dashboard Principal'
          ) {
            return item
          }
          return modulesPermission.includes(item.to) ||
            modulesPermission.includes(item?.to?.toLowerCase()) ||
            modulesPermission.includes(item.name)
            ? item
            : null
        })
        .filter(Boolean)

      filtrados = filtrados.filter((item, idx) => {
        if (item.component === 'CNavTitle') {
          const proximo = filtrados[idx + 1]
          return proximo && proximo.component !== 'CNavTitle'
        }
        return true
      })

      return filtrados
    }

    const itensPermitidos =
      user.role === 'super_admin' ? permissao : filtrarItens(permissao)

    onMounted(() => {
      firstRender.value = false
    })

    const renderItem = (item) => {
      if (item.items) {
        return h(
          CNavGroup,
          {
            ...(firstRender.value && {
              visible: item.items.some((child) => isActiveItem(route, child)),
            }),
          },
          {
            togglerContent: () => [
              h(resolveComponent('CIcon'), {
                customClassName: 'nav-icon',
                name: item.icon,
              }),
              item.name,
            ],
            default: () => item.items.map((child) => renderItem(child)),
          },
        )
      }

      return item.to
        ? h(
            RouterLink,
            {
              to: item.to,
              custom: true,
            },
            {
              default: (props) =>
                h(
                  resolveComponent(item.component),
                  {
                    active: props.isActive,
                    href: props.href,
                    onClick: () => props.navigate(),
                  },
                  {
                    default: () => [
                      item.icon &&
                        h(resolveComponent('CIcon'), {
                          customClassName: 'nav-icon',
                          name: item.icon,
                        }),
                      item.name,
                      item.badge &&
                        h(
                          CBadge,
                          {
                            class: 'ms-auto',
                            color: item.badge.color,
                          },
                          {
                            default: () => item.badge.text,
                          },
                        ),
                    ],
                  },
                ),
            },
          )
        : h(
            resolveComponent(item.component),
            {},
            {
              default: () => item.name,
            },
          )
    }

    return () =>
      h(
        CSidebarNav,
        {},
        {
          default: () => itensPermitidos.map((item) => renderItem(item)),
        },
      )
  },
})
export { AppSidebarNav }
